<template>
    <div>
        <section class="section section-shaped my-0 overflow-hidden">
            <div class="shape shape-style-1 bg-gradient-primary">
            </div>
        </section>
        <section class="section pt-5 pb-5">
            <div class="container container-lg">
                <div class="row">
                    <div class="col-lg-4">
                        <profile-navigation></profile-navigation>
                    </div>
                    <div class="col-lg-8" v-if="!orderID">
                        <h4>Meus Pedidos</h4>
                        <v-wait for="profile.load.orders"> 
                            <template slot="waiting">
                                <div class="ph-container">
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:80px"></div>
                                </div>
                            </template>
                            <p class="lead" v-if="!pedidos.length">
                              Você não possui pedidos.
                            </p>
                            <div class="table-responsive my-4" v-else>
                            <table class="table cart-table">
                              <thead>
                                <tr>
                                  <th scope="col" class="data">Data</th>
                                  <th class="text-center">Formato</th>
                                  <th>Total</th>
                                  <th>Status</th>
                                  <th></th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="pedido in pedidos" :key="pedido.id">
                                  <td>
                                    <p>{{pedido.solicitado_em}}</p>
                                  </td>
                                  <td class="text-center"><p>{{ !pedido.formato_midia ? 'Mídia Física' : 'Mídia Digital'  }}</p></td>
                                  <td><p><strong>{{returnCurrency(pedido.total)}}</strong></p></td>
                                  <td><p><span class="badge badge-light">{{pedido.status}}</span></p></td>
                                  <td class="text-right"><router-link :to="{ name: 'user-profile-order-detail', params: { order_id: pedido.id }}" class="btn btn-secondary btn-sm"><i class="fa fa-search mr-1"></i>visualizar</router-link></td>
                                </tr>
                              </tbody>
                            </table>
                            </div>
                        </v-wait>
                    </div>
                    <div class="col-lg-8" v-if="orderID">
                      <v-wait for="profile.order.detail"> 
                            <template slot="waiting">
                                <div class="ph-container">
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:140px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:50px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:25px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:25px"></div>
                                  <div class="ph-col-12 clear ph-address mb-2" style="height:125px"></div>
                                </div>
                            </template>
                            <h4>
                              Detalhes do Pedido: {{orderID}}
                              <small class="text-muted">Realizado em {{orderState.solicitado_em}}</small>
                            </h4>
                            <div class="order-steps mb-3" v-if="!orderState.cancelamento_solicitacao && !orderCancelled">
                              <ul>
                                <li :class="[orderState.status > 1 ? 'done' : 'active']">Pedido Efetuado</li>
                                <li :class="[orderState.status >= 2 ? 'done' : '']">Pagamento Aprovado</li>
                                <li :class="[orderState.status > 2 ? 'done' : '', orderState.status == 2 ? 'active' : '']">Preparando para Envio</li>
                                <li :class="[orderState.status > 3 ? 'done' : '', orderState.status == 3 ? 'active' : '']">Pedido Enviado</li>
                                <li :class="[orderState.status == 4 ? 'active' : '']">Entrega Realizada</li>
                              </ul>
                            </div>
                            <base-alert type="danger" v-else-if="orderState.cancelamento_confirmacao || orderState.status == 5">
                                <span class="alert-inner--icon"><i class="fa fa-exclamation-triangle"></i></span>
                                <span class="alert-inner--text"><strong>Pedido Cancelado!</strong></span>
                            </base-alert>
                            <base-alert type="warning" v-else>
                                <span class="alert-inner--icon"><i class="fa fa-exclamation-triangle"></i></span>
                                <span class="alert-inner--text"><strong>Aviso!</strong> O cancelamento desse pedido está sendo processado pela nossa equipe.</span>
                            </base-alert>
                            <base-alert type="info" v-if="orderState.comprovante && !orderState.cancelamento_solicitacao && !orderState.cancelamento_confirmacao && orderState.status < 2">
                                <span class="alert-inner--icon"><i class="ni ni-money-coins"></i></span>
                                <span class="alert-inner--text"><strong>Comprovante de depósito recebido!</strong> Estamos validando seu depósito para processar seu pedido.</span>
                            </base-alert>
                            <base-alert type="info" v-if="orderState.observacoes && !orderState.concluido_em">
                                <span class="alert-inner--icon"><i class="ni ni-support-16"></i></span>
                                <span class="alert-inner--text"><strong>Suporte em andamento</strong> Você relatou um problema com esse pedido.</span>
                            </base-alert>

                            <!-- detalhes do pedido -->
                            <div class="row">
                              <div class="col-lg-6 mb-4">
                                <card type="secondary" no-body>
                                  <div class="p-4">
                                    <h6>Resumo</h6>
                                    <table class="table table-sm table-borderless order-resume">
                                      <tbody>
                                        <tr>
                                          <td scope="row">Discos solicitados:</td>
                                          <td class="text-right"><strong>{{orderCheckDisks(orderState.midias)}}</strong></td>
                                        </tr>
                                        <tr>
                                          <td scope="row">Formato:</td>
                                          <td class="text-right"><strong>{{ !orderState.formato_midia ? 'Mídia Física' : `Mídia Digital (${orderState.formato_midia})` }}</strong></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </card>
                                <card type="secondary" no-body class="mt-4" v-if="orderState.endereco_envio">
                                  <div class="p-4">
                                    <h6>Endereço de Entrega</h6>
                                    <p class="address">{{orderState.endereco_envio}}</p>
                                  </div>
                                </card>
                              </div>
                              <div class="col-lg-6 mb-4">
                                <card type="secondary" no-body>
                                  <div class="p-4">
                                    <h6>Pagamento</h6>
                                    <table class="table table-sm table-borderless order-resume">
                                      <tbody>
                                        <tr>
                                          <td scope="row">Forma de Pagamento:</td>
                                          <td class="text-right"><strong>{{orderState.metodo_pagamento}}</strong></td>
                                        </tr>
                                        <tr v-if="orderState.pix_qrcode && orderState.status < 2">
                                          <td colspan="2">
                                            <img v-lazy="orderState.pix_qrcode" style="max-width: 100%; margin: 0 auto; display: table;">
                                            <div class="lazyOverlay">
                                              <img src="img/tail-spin.svg">
                                            </div>
                                          </td>
                                        </tr>
                                        <tr>
                                          <td scope="row">Custo das mídias:</td>
                                          <td class="text-right"><strong>{{returnCurrency(orderState.total - orderState.frete - orderState.taxas)}}</strong></td>
                                        </tr>
                                        <tr>
                                          <td scope="row">Custo do frete:</td>
                                          <td class="text-right"><strong>{{ orderState.frete == 0.00 ? '-' : returnCurrency(orderState.frete)}}</strong></td>
                                        </tr>
                                        <tr v-if="orderState.taxas > 0">
                                          <td scope="row">Taxas:</td>
                                          <td class="text-right"><strong>{{returnCurrency(orderState.taxas)}}</strong></td>
                                        </tr>
                                        <tr>
                                          <td scope="row">Valor total:</td>
                                          <td class="text-right"><strong>{{returnCurrency(orderState.total)}}</strong></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </card>
                              </div>
                            </div>
                            <!-- fim detalhes do pedido -->

                            <card shadow no-body v-if="orderState.status !== 5">
                              <div class="order-detail-step p-4">
                                <ul>
                                  <li v-if="orderState.status == 1">
                                    <p><strong>Em processamento</strong>
                                    <span>Seu pedido foi recebido no sistema<small>{{orderState.solicitado_em}}</small></span>
                                    <base-button v-if="orderState.metodo_pagamento !== 'Depósito Bancário' && orderState.preference_id && !orderState.pagamentos.length" class="mr-2 mb-2" :icon="[{'fa fa-barcode': orderState.metodo_pagamento == 3}, {'ni ni-credit-card': orderState.metodo_pagamento == 2}]" tag="a" @click="initializeCheckout(orderState.preference_id)"
                                                 type="secondary" size="sm">
                                        pagar agora
                                    </base-button>
                                    <base-button v-if="orderState.metodo_pagamento == 'Boleto Bancário' && orderState.pagamentos.length > 0" icon="fa fa-barcode" class="mr-2 mb-2" tag="a" @click="redirectBoleto(orderState.pagamentos)"
                                                 type="secondary" size="sm" :disabled="$wait.is('profile.order.geraboleto')">
                                        acessar boleto
                                    </base-button>
                                    <!-- enviar comprovante depósito -->
                                    <label for="comprovante">
                                      <input type="file" id="comprovante" ref="comprovante" @change="enviaComprovante()" style="display: none">
                                      <base-button v-if="['Depósito Bancário','Pix'].indexOf(orderState.metodo_pagamento) > 0 && !orderState.comprovante" class="mr-2 mb-2" icon="ni ni-money-coins" @click="comprovantePicker()"
                                                 type="secondary" size="sm" :disabled="$wait.is('profile.order.deposit.confirmation')">
                                        enviar comprovante
                                      </base-button>
                                    </label>
                                    <base-button v-if="orderState.status < 2 && !orderState.cancelamento_solicitacao" icon="fa fa-ban" tag="a" @click="solicitaCancelamento()"
                                                 type="danger" class="text-white mr-2 mb-2" size="sm" :disabled="$wait.is('profile.order.cancel.request')">
                                        solicitar cancelamento
                                    </base-button>
                                    <base-button v-if="orderState.cancelamento_solicitacao && orderState.status !== 5" icon="fa fa-ban" tag="a" @click="cancelOrderCancel(orderState.id)"
                                                 type="info" class="text-white mr-2 mb-2" size="sm" :disabled="$wait.is('profile.order.cancel.request')">
                                        desisti de cancelar
                                    </base-button>
                                    </p>
                                  </li>
                                  <li v-if="orderState.status > 1">
                                    <p><strong>Em preparação</strong>
                                    <template v-if="orderState.pagamentos.length">
                                      <template v-for="pagamento in orderState.pagamentos">
                                        <span v-if="pagamento.collection_status == 'approved'" :key="pagamento.processado_em">Estamos preparando seu pedido.<small>{{pagamento.processado_em}}</small></span>
                                      </template>
                                    </template>
                                    <span v-if="orderState.processado_em">Seu pedido está pronto para envio.<small>{{orderState.processado_em}}</small></span>
                                    </p>
                                  </li>
                                  <li v-if="orderState.status > 2">
                                    <p><strong>{{ !orderState.formato_midia ? 'A caminho' : 'Disponível' }}</strong>
                                    <span v-if="orderState.despachado_em">{{ !orderState.formato_midia ? 'Seu pacote está a caminho.' : 'Seu pedido digital está disponível para download.' }}<small>{{orderState.despachado_em}}</small></span>
                                    <base-button v-if="orderState.codigo_rastreio && !orderState.concluido_em" icon="ni ni-delivery-fast" tag="a" @click="rastrearPedido(orderState.codigo_rastreio)"
                                                 type="secondary" class="my-1" size="sm">
                                        rastrear pedido
                                    </base-button>
                                    <base-button v-if="orderState.link_download && !orderState.concluido_em" icon="ni ni-cloud-download-95" tag="a" target="_blank" :href="orderState.link_download"
                                                 type="secondary" class="my-1" size="sm">
                                        acessar arquivos
                                    </base-button>

                                    <!-- botoes confirmacao recebimento -->

                                    <base-button v-if="orderState.status == 3" icon="ni ni-check-bold" tag="a"
                                                 type="success" class="text-white my-1" size="sm" @click="modalCompleteOrder()">
                                        {{ !orderState.formato_midia ? 'confirmar recebimento' : 'confirmar download' }} 
                                    </base-button>
                                    <base-button v-if="orderState.link_download && orderState.status !== 4" icon="fa fa-info-circle" tag="a"
                                                 type="info" class="text-white my-1" size="sm" @click="formObservacao()">
                                        relatar problema 
                                    </base-button>
                                    </p>
                                  </li>
                                  <li v-if="orderState.status > 3">
                                    <p><strong>{{ !orderState.formato_midia ? 'Entregue' : 'Concluído' }}</strong>
                                    <span v-if="orderState.concluido_em">{{ !orderState.formato_midia ? 'Entregamos a sua encomenda.' : 'Você concluiu o download das mídias do pedido.' }}<small>{{orderState.concluido_em}}</small></span>
                                    </p>
                                  </li>
                                </ul>
                              </div>
                            </card>
                            <section class="section py-4">
                              <h4>Mídias do Pedido</h4>
                                <template v-if="Object.keys(orderState.midias).length">
                                  <div class="table-responsive my-4" v-for="(titulo,nome) in orderState.midias" :key="titulo.titulo_id">
                                    <table class="table cart-table">
                                      <thead>
                                        <tr v-if="titulo.length">
                                          <th scope="row" colspan="6" class="titleName">{{nome}}</th>
                                        </tr>
                                        <tr>
                                          <th scope="col" class="format">Formato</th>
                                          <th scope="col">Origem</th>
                                          <th scope="col" class="text-center">Faixas de Áudio</th>
                                          <th scope="col" v-if="isSeriado(titulo)">Temporada</th>
                                          <th scope="col" class="text-center">Discos</th>
                                        </tr>
                                      </thead>
                                      <tbody v-for="midia in titulo" :key="midia.id">
                                        <tr :class="[midia.preco ? 'gold' : '']">
                                          <td>
                                            <img width="20" height="20" :src="[midia.formato ? 'img/mediaformat/'+midia.formato+'.svg' : '']">
                                            {{midia.formato}}
                                          </td>
                                          <td><span class="badge badge-info">{{midia.origem}}</span></td>
                                          <td class="text-center"><span v-if="midia.audio" class="badge badge-success">{{midia.audio}}</span><p v-if="midia.estudios_dublagem.length">{{ midia.estudios_dublagem.join(' + ') }}</p><p v-if="midia.trecho" class="trecho">({{ midia.observacoes }})</p></td>
                                          <td v-if="isSeriado(titulo)"><p v-if="midia.temporada">{{midia.temporada}}&#170; temporada</p></td>
                                          <td class="text-center"><p>{{ !midia.discos ? '1' : midia.discos }}</p></td>
                                        </tr>
                                        <tr v-if="midia.episodios && midia.episodios.length > 0" :key="`${midia.id}-episodio-list`" :class="[midia.preco ? 'gold' : '']">
                                          <td colspan="8">
                                            <div class="episodios">
                                              <strong>Episódios presentes na mídia:</strong>
                                              <p v-for="episodio in midia.episodios" :key="episodio.id" :title="episodioFormat(episodio)">
                                                {{episodioFormat(episodio)}}
                                              </p>
                                            </div>
                                          </td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </template>
                                <div class="d-table w-100" v-if="!Object.keys(orderState.midias).length">
                                  <p class="lead text-center">Não existem mídias no pedido!</p>
                                </div>
                          </section>
                        </v-wait>
                    </div>
                </div>
            </div>
            <modal :show.sync="confirmCancel.show"
               modal-classes="modal-danger modal-dialog-centered">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Cancelar Pedido {{confirmCancel.pk}}</h6>

                <div class="py-3 text-center">
                    <i class="ni ni-cart fa-4"></i>
                    <p>Você tem certeza que deseja solicitar o cancelamento desse pedido? Até a confirmação do cancelamento, essa operação pode ser revertida.</p>
                </div>

                <template slot="footer">
                    <base-button type="white" @click="confirmOrderCancel(confirmCancel.pk)">Cancelar Pedido</base-button>
                    <base-button type="link"
                                 text-color="white"
                                 class="ml-auto"
                                 @click="confirmCancel.show = false">
                        Voltar
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="getHelp"
               modal-classes="modal modal-dialog-centered">
                <h6 slot="header" class="modal-title" id="modal-title-notification">Relatar problema com o Pedido</h6>

                <div class="py-1 text-center">
                    <textarea class="form-control" v-model="observacoes" rows="10" placeholder="Descreva o seu problema da forma mais detalhada possível"></textarea>
                </div>

                <template slot="footer">
                    <base-button type="success" @click="sendFeedback()" :disabled="this.observacoes == null || this.observacoes == ''">Enviar</base-button>
                    <base-button type="primary"
                                 class="ml-auto"
                                 @click="getHelp = false">
                        Voltar
                    </base-button>
                </template>
            </modal>
            <modal :show.sync="confirmComplete" v-if="orderState"
               modal-classes="modal-success modal-dialog-centered">
                <h6 slot="header" class="modal-title" id="modal-title-notification">{{ !orderState.formato_midia ? 'Confirmar recebimento' : 'Confirmar download' }}</h6>

                <div class="py-1 text-center">
                  <i class="fa fa-thumbs-up fa-4"></i>
                  <p>{{ !orderState.formato_midia ? 'Tudo certo com a sua encomenda? Chegou tudo certinho?' : 'Você conseguiu baixar todos os arquivos de mídias do seu pedido?' }} Clique em concluir somente se você se certificar que está tudo OK</p>
                </div>

                <template slot="footer">
                    <base-button type="white" @click="completeOrder(orderState.id)">Concluir</base-button>
                    <base-button type="link"
                      text-color="white"
                      class="ml-auto"
                      @click="confirmComplete = false">
                      Voltar
                    </base-button>
                </template>
            </modal>
        </section>
    </div>
</template>
<script>
import ProfileNavigation from './components/ProfileNavigation.vue';
import { mapActions, mapGetters } from 'vuex';

import Modal from "@/components/Modal.vue";

export default {
	name: 'profile-order',
    components: {
        ProfileNavigation,
        Modal,
    },
    data() {
    return {
      modal: {
        title: 'Falha na Solicitação!',
        body: 'Por favor, tente novamente mais tarde',
        classe: 'modal-danger',
        icon: 'ni ni-basket', 
        okButton: 'OK',
      },
      formerrors: {},
      pedidos: [],
      total_pedidos: 0,
      confirmCancel: {
        show: false,
        pk: null
      },
      confirmComplete: false,
      comprovante: null,
      getHelp: false,
      observacoes: null,
      boletoUrl: null,
      };
    },
    methods: {
        initializeCheckout(preference_id) {
          window.location = 'https://www.mercadopago.com.br/checkout/v1/redirect?pref_id='+preference_id;
        },
        formObservacao() {
          this.getHelp = true
        },
        episodioFormat(episodio) {
          let episodioString = '';
          if ( episodio.temporada ) {
            episodioString += episodio.temporada+'x';
          }
          if ( episodio.episodio ) {
            episodioString += episodio.episodio+' - ';
          }
          episodioString += episodio.titulo_traduzido+ ' ('+episodio.ano+')';
          episodioString += ' - '+ episodio.duracao +'min';
          return episodioString;
        },
        sendFeedback() {
          if (this.observacoes !== null ) {
            let payload = {
              observacoes: this.observacoes
            };
            this.axios.patch('/v1/order/'+this.orderState.id+'/', payload).then(response => {
              this.getHelp = false;
              this.localLoadOrder(this.orderState.id);
            });
          }
        },
        comprovantePicker(){
          this.$refs.comprovante.click();
        },
        enviaComprovante() {
          this.comprovante = this.$refs.comprovante.files[0];

          if (this.comprovante.size>0) {
            let size = this.comprovante.size / 1024 / 1024
            if (!this.comprovante.type.match('image.*') && !this.comprovante.type.match('application/pdf')) {
              this.modal.body = 'Por favor, selecione uma imagem ou um documento PDF';
              this.$store.dispatch('modal/invokeStateModal', this.$data.modal);
            } else if (size>3) {
              this.modal.body = 'O arquivo deve ser menor que 3MB!';
              this.$store.dispatch('modal/invokeStateModal', this.modal);
            } else {
              let formData = new FormData()
              formData.append('comprovante', this.comprovante);
              this.$wait.start('profile.order.deposit.confirmation');
              this.axios.patch('/v1/order/'+this.orderState.id+'/', formData).then(response => {
                //console.log(response);
                this.localLoadOrder(this.orderState.id);
              }).then(response => { 
                this.$wait.end('profile.order.deposit.confirmation');
              });
            }
          }          
        },
        solicitaCancelamento() {
          this.confirmCancel.pk = this.orderState.id;
          this.confirmCancel.show = true;
        },
        modalCompleteOrder(){
          this.confirmComplete = true
        },
        completeOrder(orderID) {
          this.$wait.start('profile.order.complete.request');
          this.confirmCancel.show = false;
          this.axios.post('/v1/order/'+orderID+'/complete/').then(response => {
            this.localLoadOrder(orderID);
            this.confirmComplete = false;
          }).catch(error => {
            this.modal.body = error.data.order;
            this.$store.dispatch('modal/invokeStateModal', this.modal);
          }).then(response => {
            this.$wait.end('profile.order.complete.request');
          });
        },
        confirmOrderCancel(orderID) {
          this.$wait.start('profile.order.cancel.request');
          this.confirmCancel.show = false;
          this.axios.post('/v1/order/'+orderID+'/cancel/').then(response => {
            this.localLoadOrder(orderID);
          }).catch(error => {
            this.modal.body = error.data.order;
            this.$store.dispatch('modal/invokeStateModal', this.modal);
          }).then(response => {
            this.$wait.end('profile.order.cancel.request');
          });
        },
        cancelOrderCancel(orderID) {
          this.$wait.start('profile.order.cancel.request');
          this.axios.post('/v1/order/'+orderID+'/cancel/').then(response => {
            this.localLoadOrder(orderID);
          }).catch(error => {
            this.modal.body = error.data.order;
            this.$store.dispatch('modal/invokeStateModal', this.modal);
          }).then(response => {
            this.$wait.end('profile.order.cancel.request');
          });
        },
        searchBoleto(payment, cb) {
          if ( payment.collection_id !== undefined ) {
            this.axios.get('/mercadoPagoAPI/v1/payments/'+payment.collection_id).then(response => {
              if ( response.data.transaction_details.external_resource_url ) {
                this.boletoUrl = response.data.transaction_details.external_resource_url;
              }
              cb();
            });
          }
        },
        redirectBoleto(payments) {
          this.$wait.start('profile.order.geraboleto');
          let itemsProcessed = 0;

          let requests = payments.map((payment) => {
              return new Promise((resolve) => {
                this.searchBoleto(payment, resolve);
              });
          });

          Promise.all(requests).then(() => {
            if ( this.boletoUrl !== null ) {
              window.open(this.boletoUrl);
            }else {
              /* não foi encontrada a URL do boleto, então iniciaremos o checkout normal */
              let preference_id = this.$store.state.cart.order.preference_id;
              this.initializeCheckout(preference_id);
            }
            this.$wait.end('profile.order.geraboleto');
          });         
        },
        checkDisks(media) {
          return ( media.discos !== null ) ? media.discos : 1;
        },
        orderCheckDisks(order){
          let soma = 0;
          Object.values(order).forEach(item => {
            soma += item.reduce((acc, media) => acc + this.checkDisks(media), 0);
          });
          return soma;
        },
        returnCurrency(value){
          return Number(value).toLocaleString('pt-br',{style: 'currency', currency: 'BRL'});
        },
        rastrearPedido(codigo) {
          window.open('https://www.linkcorreios.com.br/'+codigo)
        },
        isSeriado(titulo) {
          let check = titulo.filter(midia => midia.temporada !== null);
          return check.length || false;
        },
        localLoadOrder(ID) {
          this.$wait.start('profile.order.detail');
          this.loadOrder(ID)
            .then(response => {
              setTimeout(function () {
                  this.$wait.end('profile.order.detail')
              }.bind(this), 500);
            });
        },
        ...mapActions('cart', [
          'loadOrder'
        ]),
    },
    computed: {
      orderID() {
        return this.$route.params.order_id || null;
      },
      ...mapGetters('cart', [
        'orderState'
      ]),
    },
    created() {
        if ( !this.pedidos.length ) {
            this.$wait.start('profile.load.orders');
            this.axios.get('/v1/order/')
            .then(response => {
              this.total_pedidos = response.data.count;
              //this.pedidos = response.data.results;
              response.data.results.forEach((item) => {
                  item.total = parseFloat(item.total);
                  this.pedidos.push(item);
              });
              this.$wait.end('profile.load.orders');
            });
        }

        if ( this.orderID !== null && !this.orderState ) {
          this.localLoadOrder(this.orderID);
        }
    },
    beforeRouteUpdate(to, from, next) {
      let orderID = to.params.order_id || null;
      if ( orderID !== null ) {
          this.localLoadOrder(orderID);
      }
      next();
    },
    beforeRouteEnter(to, from, next) {
      let orderID = to.params.order_id || null;
      if ( orderID !== null ) {
          next(vm => {
            vm.localLoadOrder(orderID);
          });
      }
      next();
    },
};
</script>
<style lang="scss" scoped>
    h4 {
      small {
        font-size: 0.75em;
      }
    }

    p.address {
      font-size: 0.8em;
      white-space: pre-wrap; 
      word-wrap: break-word;
      line-height: 1.25;
      font-weight: 400;
      margin-bottom: 0;
    }

    h6 {
      font-weight: 700;
      font-size: 0.85em;
    }

    table.order-resume {
      font-size: 0.8em;
      margin-bottom: 0;
    }

    .order-detail-step {
      ul {
        padding-left: 25px;
        li {
          p {
            font-size: 0.9em;
            strong {
              display: block;
              font-weight: 700;
            }
            span {
              display: block;
              line-height: 1.25;
              margin: 9px 0;
              small {
                display: block;
                font-weight: 700;
                margin-top: 3px;
              }
            }
          }
        }
      }
    }

    .cart-table {
        thead {
          th {
            border-bottom: 0;
            font-size: 0.8em;
            vertical-align: middle;
            &.data {
              width: 15%;
            }
            &.titleName {
              font-size: 1.1em;
            }
          }
        }
        tbody {
          td {
            p {
              font-size: 0.85em;
              margin-bottom: 0;
              line-height: 1.25;
              strong {
                font-weight: 700;
              }
              &.trecho {
                font-size: 0.75em;
                line-height: 1;
              }
            }
          }
        }
    }

    $primary: #f5365c;
    $primary-blur: lighten($primary, 35%);
    $default: #172b4d;
    $default-blur: rgba($default, 0.5);

    .order-steps {
      width: 100%;
      display: table;
      position: relative;

      ul {
        list-style: none;
        position: relative;
        display: table;
        width: 100%;
        padding: 0;
        margin: 0;

        li {
          display: table-cell;
          width: 1%;
          text-align: center;
          padding: 20px 0;
          position: relative;
          font-size: 0.75em;
          line-height: 1.215;
          color: $default-blur;

          &:before {
            display: block;
            margin: 0 auto;
            float: none;
            content: '\2022';
            width: 30px;
            height: 30px;
            margin-bottom: 10px;
            font-size: 40px;
            font-weight: bold;
            z-index: 2;
            text-align: center;
            border: 2px solid $primary-blur;
            border-radius: 50%;
            color: $primary-blur;
            background: #fff;
            position: relative;
            line-height: 25px;
          }

          &:after {
            content: '';
            position: absolute;
            display: inline-block;
            background: $primary-blur;
            width: 100%;
            height: 2px;
            left: 50%;
            z-index: 1;
            top: 35px;
          }

          &:last-child {
            &:after {
              content: none;
            }
          }

          &.active {
            font-weight: bold;
            color: $default;
            &:before {
              border-color: $primary;
              color: $primary;
            }
          }

          &.done {
            color: $default;
            &:before {
              border-color: $primary;
              color: $primary;
            }
            &:after {
              background: $primary;
            }
          }
        }
      }
    }
</style>
